module.exports = __webpack_public_path__ + "assets/img/ffsfas.f52520c3.png";